import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter ,

} from "react-router-dom";
import { ThemeProvider,createMuiTheme } from '@material-ui/core/styles';


const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#0652dd',
        },
        secondary: {
            main: '#00ff00',
        },
    },
});


ReactDOM.render(
  <React.StrictMode>
      <ThemeProvider theme={theme}>

      <BrowserRouter>
    <App />
      </BrowserRouter>
      </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
